const PRIZE = {
  REWARD_TYPE: {
    AUTOMATIC: 'A',
    MANUAL: 'M',
    ALWAYS_ON: 'O',
    SPECIAL: 'S',
  },
}

// eslint-disable-next-line no-shadow
enum PrizeCategory {
  General = 'General',
  Checkout = 'Checkout',
}

export { PRIZE, PrizeCategory }
